@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.data {
  color: @address--wrapper--text-color;
  font-size: 14px;
  line-height: 20px;
  width: 165px;
}

.address-verification {
  color: @address--verification--text-color;
  font-size: 12px;
  display: flex;
  align-items: center;
  > svg {
    transform: scale(0.6);
    height: 18px;
    width: 18px;
    fill: @address--verification--fill-color;
  }
}

@media screen and (max-width: 1199px) {
  .name {
    color: @address--name--media--text-color;
  }
}
